import { FC, useEffect, useState } from "react";
import FrPersonalInfo from "../../components/FRPersonalInfo/frPersonalInfo";
import useAuthGuard from "../../Hooks/useAuthGuard";
import useAuthUserData from "../../Hooks/useAuthUserData";
import { registerScan, updateScanRegister } from "../../Services/scansService";
import { sendScanNotification } from "../../Services/notificationService";
import { useGetID, useQuery } from "./../../Hooks/useSuscribersService";
import { useLocation } from "react-router-dom";
import { FR_ROLE } from "../../utils/constants";

const Details = () => {
  useAuthGuard({
    allowedRoles: [
      FR_ROLE.FIRST_RESPONDER_USER,
      FR_ROLE.FIRST_RESPONDER_ADMIN,
      FR_ROLE.FIRST_RESPONDER_OWNER,
    ],
  });
  const { user } = useAuthUserData();
  const navState = useLocation();
  const [isScanRegistered, setIsScanRegistered] = useState(false);
  let query = useQuery();
  const { idSuscriber, loadUser } = useGetID(
    query.get("mmh_id")!.toLowerCase().replaceAll("mmh", "")
  );

  console.log({ scanMethod: navState.state?.scanMethod });

  useEffect(() => {
    const putScan = async () => {
      if (idSuscriber && user && !isScanRegistered) {
        if (navState?.state?.registerId) {
          await updateScanRegister(
            user?.id,
            navState?.state?.registerId,
            "Full Profile",
            navState?.state?.scanMethod ?? "MMHID"
          );
        } else {
          await registerScan(user?.id, {
            idSubscriber: idSuscriber,
            type: "Full Profile",
            method: navState?.state?.scanMethod ?? "MMHID",
          });
        }
        setIsScanRegistered(true);

        // Send email notification after successful scan registration
        try {
          await sendScanNotification({
            subscriberId: idSuscriber,
            scanMethod: navState?.state?.scanMethod ?? "MMHID",
          });
        } catch (notificationError) {
          console.error("Failed to send scan notification:", notificationError);
        }
      }
    };
    putScan();
  }, [idSuscriber, user]);

  if (loadUser) return <div>Loading...</div>;

  return (
    <div>
      {idSuscriber ? (
        <FrPersonalInfo idUser={idSuscriber} />
      ) : (
        <div>No subscriber info</div>
      )}
    </div>
  );
};

export default Details;
